import React from 'react';

const LearningGoalsContainer: React.FC<
  React.PropsWithChildren<unknown>
> = () => {
  return <>{'Learning Goals'}</>;
};

export { LearningGoalsContainer };
